<template>
  <el-dialog :title="$t('payFeeOrderConfirm.chargeConfirm')" :visible.sync="visible" width="60%" @close="handleClose">
    <el-form :model="payFeeOrderConfirmInfo" label-width="120px" class="text-left">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('payFeeOrderConfirm.payeeObject') + '：'">
            {{ payFeeOrderConfirmInfo.payerObjName }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('payFeeOrderConfirm.amountReceivable') + '：'">
            {{ payFeeOrderConfirmInfo.totalFeePrice }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('payFeeOrderConfirm.actualAmount') + '：'">
            {{ payFeeOrderConfirmInfo.receivedAmount }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('payFeeOrderConfirm.transferAmount') + '：'">
            {{ payFeeOrderConfirmInfo.transforAmount }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('payFeeOrderConfirm.discountAmount') + '：'">
            {{ payFeeOrderConfirmInfo.totalDiscountMoney.toFixed(2) }}
          </el-form-item>
        </el-col>
        <el-col v-if="payFeeOrderConfirmInfo.transforAmount > 0" :span="12">
          <el-form-item :label="$t('payFeeOrderConfirm.transferFee')">
            <el-select v-model="payFeeOrderConfirmInfo.ruleId" style="width:100%">
              <el-option :label="$t('payFeeOrderConfirm.requiredTransferFee')" value="" disabled></el-option>
              <el-option v-for="(item, index) in payFeeOrderConfirmInfo.transforPreFees" :key="index"
                :value="item.ruleId" :label="item.feeName"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="payFeeOrderConfirmInfo.integralAmount">
        <el-col :span="12">
          <el-form-item :label="$t('payFeeOrderConfirm.pointsDeduction') + '：'">
            {{ payFeeOrderConfirmInfo.integralAmount }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="payFeeOrderConfirmInfo.cashAmount">
        <el-col :span="12">
          <el-form-item :label="$t('payFeeOrderConfirm.accountDeduction') + '：'">
            {{ payFeeOrderConfirmInfo.cashAmount }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$t('payFeeOrderConfirm.remark') + '：'">
            {{ payFeeOrderConfirmInfo.remark }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item v-if="payFeeOrderConfirmInfo.payType == 'qrCode' || payFeeOrderConfirmInfo.payType == 'qinghe'"
            :label="$t('payFeeOrderConfirm.authCode')">
            <input id="authCode" ref="authCode" v-model="payFeeOrderConfirmInfo.authCode"
              :placeholder="$t('payFeeOrderConfirm.authCodePlaceholder')"
              @keydown.enter.prevent="_qrCodePayFee" class="custom-input" type="text">
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div v-if="payFeeOrderConfirmInfo.payType == 'yudifu'" class="qr-code-container"
      style="width: 100%; text-align: center;">
      <div v-if="payFeeOrderConfirmInfo.qrCodeUrl">
        <img :src="payFeeOrderConfirmInfo.qrCodeUrl" style="max-width: 240px; margin-bottom: 10px;">
        <p>{{ $t('payFeeOrderConfirm.scanPay') }}</p>
      </div>
      <div v-else>
        <p>{{ $t('payFeeOrderConfirm.generatingQrCode') }}</p>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('payFeeOrderConfirm.close') }}</el-button>
      <el-button v-if="payFeeOrderConfirmInfo.payType == 'common'" type="primary" @click="_payFee">{{
        $t('payFeeOrderConfirm.confirmCharge') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { qrCodePayment, checkPayFinish, payFee, listPrePayFeeRule } from '@/api/fee/payFeeOrderApi'
import { dateFormatH } from '@/utils/dateUtil'

export default {
  name: 'PayFeeOrderConfirm',
  data() {
    return {
      visible: false,
      communityId: '',
      payFeeOrderConfirmInfo: {
        totalDiscountMoney: 0.0,
        totalUserAmount: 0.0,
        qrCodeUrl: null,
        payType: '',
        authCode: '',
        orderId: '',
        paymentPoolId: '',
        transforAmount: 0,
        transforPreFees: [],
        ruleId: '',
        feeReceivedAmount: '',
        rules: []
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
  },
  methods: {
    open(data) {
      // 保留响应式对象，避免替换导致新增属性不响应
      Object.assign(this.payFeeOrderConfirmInfo, data)
      // 确保这些字段存在且为初始值
      this.payFeeOrderConfirmInfo.transforPreFees = []
      this.payFeeOrderConfirmInfo.transforAmount = 0
      this.payFeeOrderConfirmInfo.ruleId = ''
      this.payFeeOrderConfirmInfo.feeReceivedAmount = data.receivedAmount
      const transforAmount = parseFloat(data.receivedAmount) - parseFloat(data.orgReceivedAmount)
      if (transforAmount > 0) {
        this.payFeeOrderConfirmInfo.transforAmount = transforAmount.toFixed(2)
        // 聚焦到输入框
        this._loadTransforPrePayFees()
      }
      this.visible = true
      this.payFeeOrderConfirmInfo.payType = data.payType
      if (this.payFeeOrderConfirmInfo.payType == 'yudifu') {
        this._requestYuDiFuQrCode()
      } else if (this.payFeeOrderConfirmInfo.payType != 'common') {
        this.$nextTick(() => {
          setTimeout(() => {
            this._focusAuthCode()
          }, 300)
        })
      }
    },
    _focusAuthCode() {
      // 与 hc 原版一致：优先用 ref，取不到时按 id 兜底，保证扫码枪输入落在输入框
      const el = this.$refs.authCode || document.getElementById('authCode')
      if (el) {
        el.focus()
      }
    },
    handleClose() {
      this.visible = false
    },
    async _requestYuDiFuQrCode() {
      const printFees = [{
        feeId: this.payFeeOrderConfirmInfo.feeId,
        squarePrice: this.payFeeOrderConfirmInfo.squarePrice,
        additionalAmount: this.payFeeOrderConfirmInfo.additionalAmount,
        feeName: this.payFeeOrderConfirmInfo.feeName,
        amount: this.payFeeOrderConfirmInfo.receivedAmount,
        authCode: '123456'
      }]
      const requestData = Object.assign({}, this.payFeeOrderConfirmInfo, {
        subServiceCode: 'fee.payFee',
        printFees
      })
      try {
        const res = await qrCodePayment(requestData)
        if (res.code == 0) {
          this.payFeeOrderConfirmInfo.qrCodeUrl = res.data.qrCode
        } else {
          this.$message.error(res.msg || '生成支付二维码失败')
        }
      } catch (error) {
        console.error('请求失败处理')
        this.$message.error('请求失败')
      }
    },
    async _qrCodePayFee() {
      if (!this.payFeeOrderConfirmInfo.authCode) {
        this.$message.warning(this.$t('payFeeOrderConfirm.scanCodePlaceholder'))
        return
      }
      this.payFeeOrderConfirmInfo.subServiceCode = 'fee.payFee'
      const data = this._mergeTransforPreFee()
      try {
        const res = await qrCodePayment(data)
        if (res.code == 404) {
          this.$message.error(res.msg)
          if (res.data && res.data.orderId) {
            this.payFeeOrderConfirmInfo.orderId = res.data.orderId
            this.payFeeOrderConfirmInfo.paymentPoolId = res.data.paymentPoolId
            setTimeout(() => {
              this._qrCodeCheckPayFinish()
            }, 5000)
          }
          return
        }
        if (res.code != 0) {
          this.$message.error(res.msg || '支付失败')
          return
        }
        this.handleClose()
        setTimeout(() => {
          this.$emit('submitSuccess', res.data)
        }, 1500)
      } catch (error) {
        console.error('扫码支付失败', error)
        this.$message.error('扫码支付失败')
      }
    },
    async _qrCodeCheckPayFinish() {

      this.payFeeOrderConfirmInfo.subServiceCode = 'fee.payFee'
      const data = this._mergeTransforPreFee()
      try {
        const res = await checkPayFinish(data)
        if (res.code == 404) {
          this.$message.error(res.msg)
          return
        } else if (res.code == 41) {
          setTimeout(() => {
            this._qrCodeCheckPayFinish()
          }, 5000)
          return
        }
        this.handleClose()
        setTimeout(() => {
          this.$emit('submitSuccess', res.data)
        }, 1500)
      } catch (error) {
        console.error('检查支付状态失败', error)
        this.$message.error('检查支付状态失败')
      }
    },
    async _payFee() {

      const data = this._mergeTransforPreFee()
      try {
        const { data: responseData, code, msg } = await payFee(data)
        if (code == 0) {
          this.handleClose()
          setTimeout(() => {
            this.$emit('submitSuccess', responseData)
          }, 1500)
          return
        } else {
          this.$message.error(msg)
        }
      } catch (error) {
        console.error('请求失败处理')
        this.$message.error('请求失败')
      }
    },
    _mergeTransforPreFee() {
      const data = Object.assign({}, this.payFeeOrderConfirmInfo)
      const ruleId = data.ruleId
      const rules = data.rules
      if (ruleId) {
        rules.push({
          ruleId,
          cycles: 24,
          receivedAmount: data.transforAmount,
          startMonth: dateFormatH(new Date())
        })
      }
      const receivedAmount = data.receivedAmount
      if (rules.length < 1) {
        data.feeReceivedAmount = receivedAmount
        return data
      }
      let ruleAmount = 0
      rules.forEach(rule => {
        ruleAmount += parseFloat(rule.receivedAmount)
      })
      const feeReceivedAmount = parseFloat(receivedAmount) - ruleAmount
      data.feeReceivedAmount = feeReceivedAmount.toFixed(2)
      return data
    },
    async _loadTransforPrePayFees() {
      try {
        const params = {
          communityId: this.communityId,
          payerObjId: this.payFeeOrderConfirmInfo.payerObjId,
          payerObjType: this.payFeeOrderConfirmInfo.payerObjType
        }
        console.log('Loading transfor pre pay fees with params:', params)
        const { data } = await listPrePayFeeRule(params)
        // 使用 $set 确保响应式更新
        this.$set(this.payFeeOrderConfirmInfo, 'transforPreFees', data.rules || [])
      } catch (error) {
        console.error('加载预付费用规则失败:', error)
        // 设置空数组避免界面错误
        this.$set(this.payFeeOrderConfirmInfo, 'transforPreFees', [])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
}

.qr-code-container {
  margin-top: 20px;
}

.custom-input {
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  background-color: #fff;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  box-sizing: border-box;
  -webkit-appearance: none;
  outline: none;
}

.custom-input:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.custom-input:hover {
  border-color: #c0c4cc;
}

.custom-input::placeholder {
  color: #c0c4cc;
}
</style>